import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Supabase project configuration from environment variables
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.');
}

/**
 * Supabase client instance with optimized configuration.
 * Import and use this instance throughout your application:
 * @example
 * import { supabase } from "@/integrations/supabase/client";
 */
export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? localStorage : undefined,
    },
    db: {
      schema: 'public',
    },
    global: {
      headers: {
        'X-Client-Info': 'nostrimed-webapp/1.0',
      },
    },
    realtime: {
      params: {
        eventsPerSecond: 10, // Limit realtime events to prevent connection overload
      },
    },
  }
);